import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65167330"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "collections"
}
const _hoisted_2 = { class: "collections__heading" }
const _hoisted_3 = { class: "collections__list" }
const _hoisted_4 = { class: "item__image" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "item__title" }

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useIp, useInfo } from '@/store';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'Collections',
  setup(__props) {

_useCssVars(_ctx => ({
  "9366f66e": (_unref(bg).pc),
  "0998a710": (_unref(bg).mobile),
  "ab000214": (_unref(itemBg).pc),
  "4bdce934": (_unref(textFrame).pc),
  "6054393a": (_unref(textFrame).mobile)
}))

const { t } = useI18n();
const { collections } = storeToRefs(useIp());
const { getImg } = useInfo();
const bg = computed(() => ({
  pc: `url(${getImg('ip_pc_collection_bg')})`,
  mobile: `url(${getImg('ip_mobile_collection_bg')})`,
}));
const itemBg = computed(() => ({
  pc: `url(${getImg('ip_mobile_item_bg')})`,
}));
const textFrame = computed(() => ({
  pc: `url(${getImg('ip_pc_text_frame')})`,
  mobile: `url(${getImg('ip_mobile_text_frame')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(collections).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('IW_P3_COLLECTION') || 'IW_P3_COLLECTION'), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collections), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: item.image,
                  alt: item.name
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(item.name), 1)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})